import { BookOpen, Library, FileUp, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import AdminSectionLayout from "../components/admin/AdminSectionLayout";
import AdminTile from "../components/admin/AdminTile";

/**
 * AdminContent — Feb 6, 2026 (preview-fix Feb 6, 2026 PM).
 *
 * Only tiles that open their OWN dedicated page are shown. Sections
 * tree / homework / PDI training material live in the legacy panel
 * and are surfaced as one explicit link.
 */
export default function AdminContent() {
  return (
    <AdminSectionLayout
      title="Content"
      subtitle="Homework · learning cards · roundabouts · PDI training"
      icon={BookOpen}
      accent="indigo"
      testid="admin-content-page"
    >
      <AdminTile
        to="/admin/content-library"
        icon={Library}
        label="Content library"
        desc="Browse and edit every learner-facing card"
        accent="indigo"
        testid="admin-content-tile-library"
      />
      <AdminTile
        to="/admin/curriculum"
        icon={FileUp}
        label="Curriculum import"
        desc="Bulk upload · sync from sheet · audit"
        accent="emerald"
        testid="admin-content-tile-curriculum"
      />

      <Link
        to="/admin/legacy"
        data-testid="admin-content-legacy-link"
        className="flex items-center gap-2 mt-4 px-4 py-3 rounded-xl text-xs text-slate-500 hover:text-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
      >
        <ExternalLink className="w-3.5 h-3.5" />
        <span>Sections tree · homework · PDI training (legacy panel)</span>
      </Link>
    </AdminSectionLayout>
  );
}
